import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import QrCodeScannerRoundedIcon from '@mui/icons-material/QrCodeScannerRounded'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import QrScanFrame from '../../../generic/qr/QrScanFrame'
import { EYEBROW_SX } from '../../../generic/qr/qrReadingStyles'
import { QR_ACTIONS } from './qrLookupApi'

// What a label will get the operator, by the action the station configured (RN26).
const INSTRUCTIONS = {
  [QR_ACTIONS.SHEET]: 'Scan a label to see its documents',
  [QR_ACTIONS.JOB_DETAIL]: 'Scan an FO or a part to open its job on this machine'
}

/**
 * The widget with nothing read yet: the same viewfinder the reading dialog waits in, with the words
 * this widget answers for — the state of the reader, and what a label will get the operator.
 *
 * `framed` is off in a widget two cells tall, where 160px minus the header leaves around one line: the
 * art and the instruction give way to the state, and the button below says what to do about it.
 */
const QrScanTarget = ({ framed = true, action = QR_ACTIONS.SHEET }) => {
  const { t_ } = useSmartTranslation()

  return (
    <QrScanFrame
      framed={framed}
      direction={framed ? 'column' : 'row'}
      gap={framed ? 0.375 : 1}
      maxHeight={framed ? '7.5rem' : 'none'}
    >
      <QrCodeScannerRoundedIcon
        sx={{
          fontSize: framed ? '2rem' : '1.25rem',
          color: 'primary.main',
          opacity: 0.9,
          flexShrink: 0
        }}
      />

      <Box sx={{ minWidth: 0, textAlign: framed ? 'center' : 'left' }}>
        <Typography sx={EYEBROW_SX} noWrap>{t_('Waiting for scan')}</Typography>
        {framed && (
          <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.35 }}>
            {t_(INSTRUCTIONS[action] ?? INSTRUCTIONS[QR_ACTIONS.SHEET])}
          </Typography>
        )}
      </Box>
    </QrScanFrame>
  )
}

QrScanTarget.propTypes = {
  /** False in a widget with one line to spare: the state stays, the art and the instruction go. */
  framed: PropTypes.bool,
  /** The configured action; anything but JOB_DETAIL reads as SHEET. */
  action: PropTypes.string
}

export default QrScanTarget
